module.exports = __webpack_public_path__ + "static/media/location2.4211094f.png";